<template>
  <div class="qujianPage">
    <!-- <v-tab @handleChangeStatus="handleChangeStatus" /> -->

    <section class="layout">
      <v-search
        :formContent="formContent"
        :SearchForm="SearchForm"
        :inline="true"
        :optareBtn="optareBtn"
        @resetFn="resetFn"
        @searchFn="getListFn"
        @confirmFn="getListFn"
        @AddFn="AddFn"
        @DelFn="DelFn"
      />

      <div class="componentPage">
        <v-table
          @choozeTableFn="choozeTableFn"
          :tableData="tableData"
          :loading="loading"
          :UnitMeasurement="UnitMeasurement"
          @editRow="editRow"
        />

        <Pagination
          class="pagination"
          :total="total"
          :page.sync="SearchForm.iDisplayStart"
          :limit.sync="SearchForm.iDisplayLength"
          @pagination="getListFn"
        ></Pagination>
      </div>
    </section>
    <modal :title="$t(title)" :visible.sync="isShow" width="600px">
      <v-form
        ref="vForm"
        :optareStatus="optareStatus"
        :UnitMeasurement="UnitMeasurement"
      />

      <div slot="footer">
        <el-button type="primary" @click="isShow = false">{{
          $t('public.btn_close')
        }}</el-button>
        <el-button type="primary" @click="handleSave">{{
          $t('public.btn_confirm')
        }}</el-button>
      </div>
    </modal>
  </div>
</template>

<script>
// import tabs from './components/Tabs.vue';
import table from './components/detec/Table.vue'
import form from './components/detec/Form.vue'
import mixinForm from '@/utils/formMixins.js'

import {
  delmonitors,
  editmonitors,
  increaseds,
  monitorRange
} from '@/api/applied.js'
import { shareUnit } from '@/api/modules/public.js'
import { getIsSys } from '@/utils/permission.js'
import { getLanguage } from '@/lang';
import { TempUtils } from '@/utils/TempUtil.js';

export default {
  computed: {
    isSysAdmin () {
      return getIsSys()
    }
  },
  components: {
    // 'v-tab': tabs,
    'v-table': table,
    'v-form': form
  },

  mixins: [mixinForm],

  data () {
    return {
      SearchForm: {
        sceneName: null,
        name: null
        // type: '0'
      },
      formContent: [
        {
          id: 1,
          text: 'labelTitle.Range',
          type: 'input',
          paramsName: 'sceneName',
          isChooze: true
        },
        {
          id: 2,
          text: 'detection.mInterval',
          type: 'input',
          paramsName: 'name',
          isChooze: false
        }
      ],
      optareBtn: [
        {
          id: 1,
          icon: '',
          vHas: ['delRange'],
          text: 'buttonTitle.Add1',
          method: 'AddFn'
        },
        {
          id: 2,
          icon: '',
          vHas: ['delRange'],
          text: 'buttonTitle.Delete',
          method: 'DelFn'
        }
      ],
      choozeTable: [],
      UnitMeasurement: [],
      optareStatus: false
    }
  },
  created () {
    if (!this.isSysAdmin) {
      this.formContent.shift()
    }
    this.UnitMeasurementFn();
  },
  methods: {
    getListFn () {
      this.loading = true
      monitorRange(this.SearchForm)
        .then(({ result, pageInfo }) => {
          this.tableData = result
          this.total = pageInfo.total
          this.loading = false
        })
        .finally(() => {
          this.loading = false
        })
    },

    resetFn () {
      this.SearchForm.sceneName = null
      this.SearchForm.name = null
      this.SearchForm.iDisplayStart = 0
      this.SearchForm.iDisplayLength = 15
      this.getListFn()
    },
    /** 表格勾选 */
    choozeTableFn (array) {
      this.choozeTable = array
    },
    /** 新增 */
    AddFn () {
      this.isShow = true

      this.$nextTick(() => {
        this.optareStatus = false
        delete this.$refs.vForm.dioForm.id
        this.$refs.vForm.dioForm.max = null
        this.$refs.vForm.isShowMsg = false
        this.$refs.vForm.clearValidate()
      })
      this.title = this.$t('detection.addInterval')
    },
    UnitMeasurementFn () {
      // if (this.UnitMeasurement.length > 0) return
      shareUnit().then(({ result }) => {
        this.UnitMeasurement = result.map(item => {
          // 英文环境下 code 首字母大写
          const codeText = getLanguage() === 'zh_CN'
            ? item.title
            : (item.code ? item.code.charAt(0).toUpperCase() + item.code.slice(1) : '')
          // 统一湿度单位显示为 %RH
          const unitName = (item.name || '').replace(/%rh/gi, '%RH')
          return {
            id: item.id,
            label: codeText + `(${unitName})`,
            name: unitName,
            title: item.title
          }
        })
      })
    },
    /** 删除 */
    DelFn () {
      const msgFlag = this.tipFn()

      if (!msgFlag) return

      const ids = this.choozeTable.map(item => item.id).join(',')
      this.TODOTIPDEL({ ids })
    },
    /** 编辑 */
    editRow (row) {
      this.isShow = true

      this.title =
        this.$t('detection.edit') +
        '[' +
        row.name +
        ']' +
        this.$t('detection.monitoringInterval')
      this.$nextTick(() => {
        this.optareStatus = true
        this.$refs.vForm.clearValidate()
        this.$refs.vForm.isShowMsg = false
        let { name, scopeId, min, max, unitId, id, sceneName } = row
        const index = this.UnitMeasurement.findIndex(item => item.id === row.unitId);

        min = TempUtils.convertToCelsius(min, this.UnitMeasurement[index].name)
        max = TempUtils.convertToCelsius(max, this.UnitMeasurement[index].name)

        this.$refs.vForm.company = this.UnitMeasurement[index].name
        this.$refs.vForm.dioForm = {
          id,
          name,
          scopeId,
          min,
          max,
          unitId,
          sceneName
        }
      })
    },
    /**
     *
     * @param {*提示语} str
     */
    tipFn (str) {
      if (this.choozeTable.length === 0) {
        this.$message.warning(this.$t(str || 'public.least_one_data'))
        return false
      } else {
        return true
      }
    },
    /**
     *
     * @param {*param 选中数据id} param string
     */
    TODOTIPDEL (param) {
      this.$confirm(
        this.$t('messageTitle.DeleteToContinue'),
        this.$t('public.prompt')
      )
        .then(() => {
          delmonitors(param).then(({ state }) => {
            if (state.code === 200) {
              this.getListFn()
              this.$message.success(this.$t('public.tip_del_succ').toString())
            }
          })
        })
        .catch(() => {})
    },
    /** 保存 */
    async handleSave () {
      const childrenRef = this.$refs.vForm
      if (childrenRef.isShowMsg) return
      const flag = await childrenRef.justify()
      if (!flag) return

      childrenRef.dioForm.type = this.SearchForm.type
      let httpUrl = ''
      if (!childrenRef.dioForm.id) {
        httpUrl = increaseds
        // childrenRef.dioForm.unit_id = childrenRef.dioForm.unit_id.id;
      } else {
        httpUrl = editmonitors
        delete this.$refs.vForm.dioForm.sceneName
      }

      const query = { ...childrenRef.dioForm }
      const index = this.UnitMeasurement.findIndex(item => item.id === query.unitId);

      query.max = TempUtils.convertFormCelsius(query.max,this.UnitMeasurement[index].name)
      query.min = TempUtils.convertFormCelsius(query.min,this.UnitMeasurement[index].name)

      httpUrl(query).then(({ result, state }) => {
        if (result === 200) {
          this.$message.success(this.$t('messageTitle.OperatedSuccessfully'))
          this.getListFn()
          this.isShow = false
        } else if (result === 406) {
          this.$message.error(
            $t('integration.monitoring_interval_already_exists')
          )
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.qujianPage {
  height: 100%;
  padding: 15px;
  padding-bottom: 0;
  box-sizing: border-box;

  .layout {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
  }

  .componentPage {
    flex: 1;

    .pagination {
      padding-top: 0;
      padding-right: 15px !important;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
</style>
